import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mahasa_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Noget gik galt";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

export function dkk(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("da-DK", { style: "currency", currency: "DKK", maximumFractionDigits: 0 }).format(v);
}

export function num(n) {
  return new Intl.NumberFormat("da-DK").format(Number(n || 0));
}

export function dateDK(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("da-DK");
  } catch {
    return s;
  }
}
